module.exports = __webpack_public_path__ + "img/logo2.9b420d31.svg";